/**
 * Shared date helpers for the treatment plan review-by cadence.
 *
 * Kept pure and dependency-free — caller decides how to format for the
 * specific surface (chip, tooltip, modal header).
 */

export function daysUntil(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const target = new Date(iso);
  if (Number.isNaN(target.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  target.setHours(0, 0, 0, 0);
  return Math.round((target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}

export function formatReviewDate(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

export type ReviewUrgency = 'overdue' | 'soon' | null;

/** Derive urgency from days-until-review. null means no date or plenty of runway. */
export function reviewUrgency(days: number | null): ReviewUrgency {
  if (days === null) return null;
  if (days < 0) return 'overdue';
  if (days <= 30) return 'soon';
  return null;
}
